module.exports = __webpack_public_path__ + "static/media/V1_DIFF.659df237.png";